import type { ShapeData } from '@/lib/shapes/types/shape-data'
import type { Content } from '@/api/types/stowed-element'
import type { ParagraphBlockFontLookup } from '@/lib/text/types/paragraph-block-font-lookup'
import { ShapeTextBakeContext } from '../types/shape-text-bake-context'
import { buildShapeImageFillContent } from './build-shape-image-fill-content'
import { buildShapeTextContent } from './build-shape-text-content'

/** Photo fill and shape-text are mutually exclusive on the wire (`Content` is a oneof); a photo fill wins. */
export function buildShapeContent(
  shape: ShapeData,
  fonts?: ParagraphBlockFontLookup,
  bake?: ShapeTextBakeContext
): Content | undefined {
  return buildShapeImageFillContent(shape) ?? buildShapeTextContent(shape, fonts, bake)
}
